import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from 'containers/PrivateRoute';
import PublicRoute from 'containers/PublicRoute';
import Dashboard from 'containers/Dashboard/Loadable';
import UserProfilePage from 'containers/UserProfilePage/Loadable';
import LoginPage from 'containers/LoginPage/Loadable';
import RegisterPage from 'containers/RegisterPage/Loadable';
import ForgotPasswordPage from 'containers/ForgotPasswordPage/Loadable';
import ResetPasswordPage from 'containers/ResetPasswordPage/Loadable';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import {
  WELCOME,
  DASHBOARD,
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  USER_PROFILE,
  ABOUT,
  STRUCTURE,
  MEMBERS,
  PROJECTS,
  CONTACT,
  ARTICLES,
  SINGLE_ARTICLE,
  MEDIA,
  SERVICES,
  COMPANIES,
  SINGLE_COMPANY,
  INOVATION_POOL,
  VMC_CLINIC,
  VMC_FORUM,
  DOCUMENTS,
  SOK_PROJECT_PAGE
} from 'routes';
import HomePage from 'containers/HomePage';
import AboutPage from 'containers/AboutPage';
import StructurePage from 'containers/StructurePage';
import MembersPage from 'containers/MembersPage';
import ProjectsPage from 'containers/ProjectsPage';
import ContactPage from 'containers/ContactPage';
import ArticlesPage from 'containers/ArticlesPage';
import SingleArticlePage from 'containers/ArticlesPage/SingleArticlePage';
import NotFound from 'components/NotFound/NotFound';
import CompaniesPage from 'containers/CompaniesPage/CompaniesPage';
import SingleCompanyPage from 'containers/CompaniesPage/SingleCompanyPage';
import MediaPage from 'containers/MediaPage';
import InovationPoolPage from 'containers/InovationPoolPage/InovationPool';
import PageInProgress from 'components/PageInProgress/PageInProgress';
import DocumentsPage from 'containers/DocumentsPage/DocumentsPage';
import SokProjectPage from 'containers/SokProject/SokProjectPage';

export default function Routes() {
  return (
    <Switch>
      <PublicRoute exact path={WELCOME} component={HomePage} />
      <PublicRoute exact path={ABOUT} component={AboutPage} />
      <PublicRoute exact path={STRUCTURE} component={StructurePage} />
      <PublicRoute exact path={MEMBERS} component={MembersPage} />
      <PublicRoute exact path={PROJECTS} component={ProjectsPage} />
      <PublicRoute exact path={MEDIA} component={MediaPage} />
      <PublicRoute exact path={SERVICES} component={NotFound} />
      <PublicRoute exact path={CONTACT} component={ContactPage} />
      <PublicRoute exact path={COMPANIES} component={CompaniesPage} />
      <PublicRoute exact path={DOCUMENTS} component={DocumentsPage} />
      <PublicRoute exact path={SINGLE_COMPANY} component={SingleCompanyPage} />
      <PublicRoute exact path={ARTICLES} component={ArticlesPage} />
      <PublicRoute exact path={SINGLE_ARTICLE} component={SingleArticlePage} />
      <PublicRoute exact path={INOVATION_POOL} component={InovationPoolPage} />
      <PublicRoute exact path={VMC_CLINIC} component={PageInProgress} />
      <PublicRoute exact path={SOK_PROJECT_PAGE} component={SokProjectPage} />
      <PublicRoute exact path={VMC_FORUM} component={PageInProgress} />

      <PrivateRoute exact path={DASHBOARD} component={Dashboard} />
      <PrivateRoute exact path={USER_PROFILE} component={UserProfilePage} />
      <PublicRoute exact path={LOGIN} component={LoginPage} />
      <PublicRoute exact path={REGISTER} component={RegisterPage} />
      <PublicRoute
        exact
        path={FORGOT_PASSWORD}
        component={ForgotPasswordPage}
      />
      <PublicRoute exact path={RESET_PASSWORD} component={ResetPasswordPage} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
}
